var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", {}, [
    _c("div", { staticClass: "row gx-3" }, [
      _c("div", { staticClass: "col-6" }, [
        _c(
          "label",
          { staticClass: "form-label", attrs: { for: "date_picker" } },
          [_vm._v(_vm._s(_vm.$t("icsearch_kiedy")))]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "icpkp-datepicker" },
          [
            _c("ic-date-picker", {
              attrs: {
                format: "YYYY-MM-DD",
                type: "date",
                id: "date_picker",
                name: "date",
                hideControls: true,
                title: "",
                endDate: _vm.endDateDynamic,
              },
              model: {
                value: _vm.wartosc,
                callback: function ($$v) {
                  _vm.wartosc = $$v
                },
                expression: "wartosc",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-6" }, [
        _c(
          "label",
          { staticClass: "form-label", attrs: { for: "ic-seek-time" } },
          [_vm._v(_vm._s(_vm.$t("icsearch_godzina")))]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "input-group time-picker" }, [
          _c("input", {
            staticClass: "jsTimepickerItem form-control clock-icon",
            attrs: {
              type: "text",
              name: "time",
              id: "ic-seek-time",
              "aria-label": _vm.$t("icsearch_aria_godzina"),
            },
            domProps: { value: _vm.formatujCzas() },
          }),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }